export const getContentfulUrl = (id?: string) => {
  if (!id) {
    return '';
  }

  return `https://app.contentful.com/spaces/${process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID}/entries/${id}`;
};
